document.addEventListener("DOMContentLoaded", function () {
  const productJsonEl = document.getElementById("product-json");
  if (!productJsonEl) return;
  const productData = JSON.parse(productJsonEl.textContent);

  const variantInputs = document.querySelectorAll(".variant-id-input");
  const qtyInputs = document.querySelectorAll(".cart-qty-input");
  const qtyUI = document.querySelector(".quantity-input");
  const addToCartBtn = document.querySelector(".add-cart-btn");
  const buyNowBtn = document.querySelector(".buy-now-btn");
  const newPriceEl = document.querySelector(".new-price");
  const oldPriceEl = document.querySelector(".old-price");

  /* ==========================
     QUANTITY HANDLER
  ========================== */
  function updateQuantity(val) {
    qtyInputs.forEach(input => input.value = val);
  }
  if (qtyUI) {
    const plusBtn = document.querySelector(".plus");
    const minusBtn = document.querySelector(".minus");
    if (plusBtn && minusBtn && !plusBtn.dataset.bound) {
      plusBtn.dataset.bound = "true";
      minusBtn.dataset.bound = "true";
      plusBtn.addEventListener("click", () => {
        let val = parseInt(qtyUI.value || 1);
        val += 1;
        qtyUI.value = val;
        updateQuantity(val);
      });
      minusBtn.addEventListener("click", () => {
        let val = parseInt(qtyUI.value || 1);
        if (val > 1) val -= 1;
        qtyUI.value = val;
        updateQuantity(val);
      });
    }
  }

  /* ==========================
     AVAILABILITY HANDLER
  ========================== */
  function updateAvailability(variant) {
    if (!variant || !addToCartBtn || !buyNowBtn) return;
    if (variant.available) {
      addToCartBtn.disabled = false;
      buyNowBtn.disabled = false;
      addToCartBtn.textContent = "Add to Cart";
      buyNowBtn.textContent = "Buy Now";
    } else {
      addToCartBtn.disabled = true;
      buyNowBtn.disabled = true;
      addToCartBtn.textContent = "Sold Out";
      buyNowBtn.textContent = "Sold Out";
    }
  }

  /* ==========================
     PRICE HANDLER
  ========================== */
  function updatePrice(variant) {
    if (!variant) return;
    if (newPriceEl) newPriceEl.textContent = Shopify.formatMoney(variant.price, "{{ shop.money_format }}");
    if (oldPriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        oldPriceEl.style.display = "inline";
        oldPriceEl.textContent = Shopify.formatMoney(variant.compare_at_price, "{{ shop.money_format }}");
      } else {
        oldPriceEl.style.display = "none";
      }
    }
  }

  /* ==========================
     SWIPER INIT
  ========================== */
  const thumbsSwiper = new Swiper(".mySwiper", {
    slidesPerView: 6,
    spaceBetween: 5,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
  });
  const mainSwiper = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 5,
    allowTouchMove: false,
    thumbs: { swiper: thumbsSwiper },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  });

  /* ==========================
     IMAGE ZOOM
  ========================== */
  function enableZoom() {
    document.querySelectorAll(".mySwiper2 .product-img").forEach(box => {
      const img = box.querySelector("img");
      if (!img) return;
      let rafId = null;
      box.addEventListener("mousemove", e => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          const rect = box.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
          img.style.transform = "scale(2)";
          rafId = null;
        });
      });
      box.addEventListener("mouseleave", () => {
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center";
      });
    });
  }
  enableZoom();

  /* ==========================
     SLIDE TO VARIANT IMAGE
  ========================== */
  function slideToVariantImage(imageUrl) {
    if (!imageUrl) return;
    const mainImages = document.querySelectorAll(".mySwiper2 img");
    mainImages.forEach((img, index) => {
      if (img.dataset.image === imageUrl) {
        mainSwiper.slideToLoop(index, 0);
        thumbsSwiper.slideTo(index, 0);
        document.querySelectorAll(".mySwiper .swiper-slide").forEach(s => s.classList.remove("swiper-slide-thumb-active"));
        if (thumbsSwiper.slides[index]) thumbsSwiper.slides[index].classList.add("swiper-slide-thumb-active");
      }
    });
  }

  /* ==========================
     VARIANT SELECTION
  ========================== */
  function selectVariant(matchedVariant) {
    if (!matchedVariant) return;
    // Set variant input
    variantInputs.forEach(input => input.value = matchedVariant.id);
    // Update availability & price
    updateAvailability(matchedVariant);
    updatePrice(matchedVariant);
    // Slide image if exists
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      slideToVariantImage(matchedVariant.featured_image.src);
    }
  }

  function getSelectedOptions() {
    const selectedOptions = [];
    document.querySelectorAll(".product-option").forEach(opt => {
      const activeBtn = opt.querySelector(".option-swatch.active");
      selectedOptions.push(activeBtn ? activeBtn.dataset.optionValue : null);
    });
    return selectedOptions;
  }

  document.querySelectorAll(".option-swatch").forEach(swatch => {
    swatch.addEventListener("click", function() {
      const optionContainer = this.closest(".product-option");
      const optionLabel = optionContainer.querySelector(".selected-option");
      optionContainer.querySelectorAll(".option-swatch").forEach(b => b.classList.remove("active"));
      this.classList.add("active");
      optionLabel.textContent = this.dataset.optionValue;

      const selectedOptions = getSelectedOptions();
      const matchedVariant = productData.variants.find(v => v.options.every((o, i) => o === selectedOptions[i]));
      selectVariant(matchedVariant);
    });
  });

  /* ==========================
     INITIALIZE FIRST VARIANT
  ========================== */
  const firstVariant = productData.variants[0];
  if (firstVariant) {
    // Set default active buttons
    document.querySelectorAll(".product-option").forEach((opt, i) => {
      const firstOptionValue = firstVariant.options[i];
      const btn = opt.querySelector(`.option-swatch[data-option-value="${firstOptionValue}"]`);
      if (btn) btn.classList.add("active");
      opt.querySelector(".selected-option").textContent = firstOptionValue;
    });
    // Apply first variant
    selectVariant(firstVariant);
  }

  /* ==========================
     BUY NOW AJAX
  ========================== */
  const buyNowForm = document.querySelector(".buy-now-form");
  if (buyNowForm) {
    buyNowForm.addEventListener("submit", function(e) {
      e.preventDefault();
      fetch("/cart/add.js", { method: "POST", body: new FormData(this) })
        .then(() => { window.location.href = "/checkout"; })
        .catch(console.error);
    });
  }
});
